import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { scanner } from "sensor";
import { reportDevicePosition } from "utils";
import axios from "axios";
var AiSaveSensorLogModal = /** @class */ (function (_super) {
    tslib_1.__extends(AiSaveSensorLogModal, _super);
    function AiSaveSensorLogModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connectionStatus = "scanning";
        _this.connectionAttempt = 1;
        _this.connectionError = null;
        _this.cancelled = false;
        _this.progress = null;
        return _this;
    }
    Object.defineProperty(AiSaveSensorLogModal.prototype, "displayConnectionStatus", {
        get: function () {
            return (this.connectionStatus == "connecting" && this.connectionAttempt > 1)
                ? this.$t("saveSensorLog.status.connectingAttempt", [this.connectionAttempt])
                : this.$t("saveSensorLog.status." + this.connectionStatus);
        },
        enumerable: true,
        configurable: true
    });
    AiSaveSensorLogModal.prototype.beforeOpen = function (e) {
        this.device = e.params.device;
        this.connectionStatus = "scanning";
        this.connectionAttempt = 1;
        this.connectionError = null;
        this.connection = null;
        this.cancelled = false;
        this.progress = null;
        this.$root.$on("back", this.cancel);
    };
    AiSaveSensorLogModal.prototype.opened = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sensor, err_1, _a, err_2, logData, err_3, err_4;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        reportDevicePosition(this.device.serial, "Sensor");
                        this.connectionStatus = "scanning";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, scanner.findBySerial(this.device.serial)];
                    case 2:
                        sensor = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.connectionError = this.$te("error." + err_1.code)
                            ? this.$t("error." + err_1.code)
                            : this.$t("error.UNKNOWN_BLUETOOTH", [err_1.code, err_1.message]);
                        this.connectionStatus = "error";
                        return [2 /*return*/];
                    case 4:
                        if (this.cancelled)
                            return [2 /*return*/];
                        this.connectionStatus = "connecting";
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, , 8]);
                        _a = this;
                        return [4 /*yield*/, scanner.connect(sensor, function (a) { return _this.connectionAttempt = a; })];
                    case 6:
                        _a.connection = _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _b.sent();
                        this.connectionError = this.$te("error." + err_2.code)
                            ? this.$t("error." + err_2.code)
                            : this.$t("error.UNKNOWN_BLUETOOTH", [err_2.code, err_2.message]);
                        this.connectionStatus = "error";
                        return [2 /*return*/];
                    case 8:
                        this.connectionStatus = "downloading";
                        _b.label = 9;
                    case 9:
                        _b.trys.push([9, 11, 12, 13]);
                        return [4 /*yield*/, this.connection.readLog(function (progress) {
                                _this.progress = progress;
                            })];
                    case 10:
                        logData = _b.sent();
                        return [3 /*break*/, 13];
                    case 11:
                        err_3 = _b.sent();
                        this.connectionError = this.$te("error." + err_3.code)
                            ? this.$t("error." + err_3.code)
                            : this.$t("error.UNKNOWN_BLUETOOTH", [err_3.code, err_3.message]);
                        this.connectionStatus = "error";
                        return [2 /*return*/];
                    case 12:
                        this.progress = null;
                        if (this.connection) {
                            this.connection.dispose();
                            this.connection = null;
                        }
                        return [7 /*endfinally*/];
                    case 13:
                        if (this.cancelled)
                            return [2 /*return*/];
                        this.connectionStatus = "uploading";
                        _b.label = 14;
                    case 14:
                        _b.trys.push([14, 16, , 17]);
                        return [4 /*yield*/, axios.post("devicesensorlog/sensorlog", {
                                serialNumber: this.device.serial,
                                logData: logData,
                            })];
                    case 15:
                        _b.sent();
                        return [3 /*break*/, 17];
                    case 16:
                        err_4 = _b.sent();
                        this.connectionError = this.$t("error.INTERNET_CONNECTION_ERROR");
                        this.connectionStatus = "error";
                        return [2 /*return*/];
                    case 17:
                        this.connectionStatus = "completed";
                        return [2 /*return*/];
                }
            });
        });
    };
    AiSaveSensorLogModal.prototype.closed = function () {
        this.cancelled = true;
        scanner.cancelScan();
        if (this.connection) {
            this.connection.dispose();
            this.connection = null;
        }
        this.$root.$off("back", this.cancel);
    };
    AiSaveSensorLogModal.prototype.cancel = function (e) {
        if (e && e.stop)
            e.stop();
        this.$modal.hide("save-sensor-log");
    };
    AiSaveSensorLogModal = tslib_1.__decorate([
        Component
    ], AiSaveSensorLogModal);
    return AiSaveSensorLogModal;
}(Vue));
export default AiSaveSensorLogModal;
